import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { white, yellow } from '../../styles/colors';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { NavigationActionGlyph } from '../NavigationActionGlyph/NavigationActionGlyph';
import { NavigationLabel } from '../NavigationLabel/NavigationLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "uoevvn-0"
})(["box-sizing:border-box;height:100%;display:flex;align-items:center;line-height:normal;box-shadow:inset 0 -4px 0px -2px ", ";"], props => props.selected ? yellow : 'transparent');
const GlobalNavigationItem = /*#__PURE__*/forwardRef(function GlobalNavigationItem(_ref, forwardedRef) {
  let {
    children,
    glyph,
    href,
    selected = false,
    action,
    disabled = false
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "glyph", "href", "selected", "action", "disabled"]);

  return /*#__PURE__*/_jsx(Container, Object.assign({}, restProps, {
    selected: selected,
    children: /*#__PURE__*/_jsx(Button, {
      ref: forwardedRef,
      variant: "tertiary",
      href: href,
      disabled: disabled,
      "aria-current": selected ? 'location' : undefined,
      children: /*#__PURE__*/_jsxs(NavigationLabel, {
        children: [glyph && /*#__PURE__*/_jsx(Icon, {
          glyph: glyph,
          size: "xsmall",
          primaryColor: selected ? yellow : white
        }), children, action && /*#__PURE__*/_jsx(NavigationActionGlyph, {
          action: action,
          size: "xsmall"
        })]
      })
    })
  }));
});
GlobalNavigationItem.propTypes = {
  href: T.string,
  children: T.node,
  disabled: T.bool,
  selected: T.bool,
  glyph: T.elementType,
  action: T.oneOf(['dropdown', 'follow']),
  dividers: T.arrayOf(T.oneOf(['left', 'right']))
};
export { GlobalNavigationItem };